import ZuiContentHeader from '@zenbusiness/zui/ContentHeader';
import Grid from '@zenbusiness/zui/Grid';
import Heading from '@zenbusiness/zui/Heading';
import Link from '@zenbusiness/zui/Link';
import { superstyled } from '@zenbusiness/zui/styles';

export const ContentHeader = superstyled({
  tag: ZuiContentHeader,
  name: 'AccountNotFound',
  slot: 'ContentHeader',
  styles: {
    textAlign: 'center',
    marginBottom: 0
  }
});

export const GridContainer = superstyled({
  tag: Grid,
  name: 'MobileAccountNotFound',
  slot: 'GridContainer',
  propsAdded: {
    alignItems: 'center',
    container: true,
    direction: 'column',
    justifyContent: 'flex-start',
    margin: 0,
    gap: 4,
    width: '100%',
    marginTop: { xs: 4, md: 8 },
    maxWidth: '892px'
  }
});

export const InlineLink = superstyled({
  tag: Link,
  name: 'MobileAccountNotFound',
  slot: 'InlineLink',
  propsAdded: {
    weight: 'medium',
    underline: 'none'
  }
});

export const SectionHeading = superstyled({
  tag: Heading,
  name: 'MobileAccountNotFound',
  slot: 'SectionHeading',
  propsAdded: {
    align: 'left',
    size: 'xl',
    weight: 'medium',
    component: 'h2'
  },
  styles: ({ theme }) => ({
    marginBottom: theme.spacing(0.5)
  })
});

export const ListWithLessPadding = superstyled({
  tag: 'ul',
  name: 'MobileAccountNotFound',
  slot: 'ListWithLessPadding',
  styles: {
    paddingInlineStart: '1.5rem',
    listStyleType: 'disc'
  }
});
